import { post, get } from './index'
export default {
  //公司动态
  getCompanyNewsByCondition: (params) => post('companyNews/getCompanyNewsByCondition', params),
  getDetails: (id) => get('companyNews/getDetails/' + id)
};
